export class Label {
	label_printer:string = "";
	normal_printer:string[] = [];

	public constructor(data?:any) {
		if (!data) return;
		this.label_printer = data.label_printer;
		this.normal_printer = data.normal_printer;
	}
}